export enum RoomStatus {
    Available = 1,
    Occupied = 2,
}
export const RoomStatusLabels: Record<RoomStatus, string> = {
    [RoomStatus.Available]: "Available",
    [RoomStatus.Occupied]: "Occupied",
};